module.exports = __webpack_public_path__ + "static/media/kaist.cc924d2b.png";